module.exports = __webpack_public_path__ + "img/camera_b.8b6ad68e.svg";